import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { EMPTY_SEARCH_RESPONSE } from 'owa-timestream-3s-search';
import { loading, getSearchError } from 'owa-timestream-search-store';
import { NetworkError } from 'owa-timestream-loadingpanel';
import showingResults from '../selectors/showingResults';

export default observer(function EmptySearchResponse() {
    if (loading() || showingResults() || getSearchError() !== EMPTY_SEARCH_RESPONSE) {
        return null;
    }

    return <NetworkError />;
});
